import React from 'react'
import MainNavigation from '../components/Navigation'

export default function Challenges() {
  return (
    <div>
      <MainNavigation />
      <div>
         Challenges
      </div>
      </div>
  )
}
